import { Box, Flex, Image } from "@chakra-ui/react";
import { useMobileBreakpoint } from "../../../utils/useBreakpoints";

export function HolidayBundlePublisherLogos() {
  const isMobileBreakpoint = useMobileBreakpoint();

  return (
    <Flex
      flexDirection="column"
      width="100%"
      alignItems="center"
      mt="40px"
      mb="16px"
    >
      <Flex
        width="100%"
        maxWidth="600px"
        justifyContent="center"
        alignItems="center"
        gap={isMobileBreakpoint ? "16px" : "96px"}
        flexWrap={isMobileBreakpoint ? "wrap" : "nowrap"}
        px={isMobileBreakpoint ? "20px" : "0"}
      >
        <Box
          width={isMobileBreakpoint ? "calc(50% - 8px)" : "auto"}
          height="52px"
          minWidth="120px"
          flex={isMobileBreakpoint ? "none" : "1"}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Image
            src={`${window.gc.global.assets_url}/static/images/web-ui/holiday-bundle/dark_horse_logo.png`}
            alt="Dark Horse"
            maxWidth="100%"
            maxHeight="100%"
            objectFit="contain"
          />
        </Box>
        <Box
          width={isMobileBreakpoint ? "calc(50% - 8px)" : "52px"}
          // py='10px'
          height="52px"
          minWidth="52px"
          flex={isMobileBreakpoint ? "none" : "1"}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Image
            src={`${window.gc.global.assets_url}/static/images/web-ui/holiday-bundle/dc_logo.png`}
            alt="DC"
            maxWidth="100%"
            maxHeight="100%"
            objectFit="contain"
          />
        </Box>
        <Box
          py='10px'
          width={isMobileBreakpoint ? "calc(50% - 8px)" : "146px"}
          height="52px"
          minWidth="146px"
          flex={isMobileBreakpoint ? "none" : "1"}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Image
            src={`${window.gc.global.assets_url}/static/images/web-ui/holiday-bundle/kondansha_logo.png`}
            alt="Kodansha"
            maxWidth="100%"
            maxHeight="100%"
            objectFit="contain"
          />
        </Box>
        <Box
          py='10px'
          width={isMobileBreakpoint ? "calc(50% - 8px)" : "86px"}
          height="52px"
          minWidth={isMobileBreakpoint ? "120px" : "86px"}
          flex={isMobileBreakpoint ? "none" : "0 0 86px"}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Image
            src={`${window.gc.global.assets_url}/static/images/web-ui/holiday-bundle/marvel_logo.png`}
            alt="Marvel"
            maxWidth="100%"
            maxHeight="100%"
            objectFit="contain"
          />
        </Box>
      </Flex>
    </Flex>
  );
}
